/* Native overflow remains usable without JS; custom element lifecycle supports
   Shopify section add/remove/reorder without duplicate listeners. */
if (!customElements.get('eightoon-products')) {
  customElements.define('eightoon-products', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-product-track]');
      this.controls = this.querySelector('[data-product-controls]');
      if (!this.track || !this.controls) return;
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.controls.addEventListener('click', (event) => {
        const button = event.target.closest('button[data-direction]');
        if (!button) return;
        const direction = button.dataset.direction === 'next' ? 1 : -1;
        this.track.scrollBy({ left: direction * this.track.clientWidth,
          behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      }, options);
      this.track.addEventListener('scroll', () => this.updateControls(), { ...options, passive: true });
      this.resizeObserver = new ResizeObserver(() => this.updateControls());
      this.resizeObserver.observe(this.track);
      this.updateControls();
    }
    updateControls() {
      const overflow = this.track.scrollWidth - this.track.clientWidth;
      this.controls.hidden = overflow <= 2;
      this.controls.querySelector('[data-direction="previous"]').disabled = this.track.scrollLeft <= 2;
      this.controls.querySelector('[data-direction="next"]').disabled = this.track.scrollLeft >= overflow - 2;
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.resizeObserver?.disconnect();
    }
  });
}

/**
 * Applies newest-first as the collection page's initial sort while preserving
 * a visitor's explicit sort choice and any active filters.
 */
function applyDefaultCollectionSort() {
  try {
    const productGrid = document.querySelector('[data-e8-default-sort]');
    if (!productGrid) return;

    const url = new URL(window.location.href);
    if (url.searchParams.has('sort_by')) return;

    url.searchParams.set('sort_by', productGrid.dataset.e8DefaultSort);
    window.location.replace(url.toString());
  } catch (error) {
    console.error('EIGHTOON: 商品一覧の並び順を設定できませんでした。', error);
  }
}

applyDefaultCollectionSort();
